import "./ConsentForm.scss";
import { deepClone } from "src/legacy/utils/helpers";
import { Typography } from "src/latest/src/components";

interface Props {
    data: any;
    onDataInput: (updatedAnswers: any) => void;
    answersObject: any;
    currentPage: number;
}

export const ConsentInputBox = ({
    data,
    onDataInput,
    answersObject,
    currentPage,
}: Props) => {
    function handleInputChange(answerUniqueKey: string, event: any): void {
        const _answersObject = deepClone(answersObject);
        const value = event?.target?.value?.trim();

        if (_answersObject && answerUniqueKey && value) {
            _answersObject[currentPage][answerUniqueKey] = {
                error: undefined,
                answersData: [value],
            };
        } else {
            _answersObject[currentPage][answerUniqueKey] = {
                error: "is_required",
            };
        }

        if (onDataInput) {
            onDataInput(_answersObject);
        }
    }

    return (
        <div style={{ marginBottom: "1rem" }}>
            <div
                style={{ paddingLeft: "2rem" }}
                className="consent-items-group"
            >
                <Typography variant='size-18' weight='bold' color='color-2'>{data?.display_title}</Typography>
                <div
                    id={`consent-${data.unique_key}`}
                    style={{ display: "flex", marginTop: "2rem" }}
                >
                    <label className="col-sm-2 col-form-label">
                        {data?.display_label}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id={data.unique_key}
                        placeholder="Please enter your name*"
                        onChange={(e) => {
                            handleInputChange(data.unique_key, e);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
